var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCardVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 48,
    viewBox: "0 0 75 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.171875,
    width: 74.4348,
    height: 48,
    rx: 5,
    fill: "#003F7C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2056_9522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4535 20.3382C38.4182 23.1372 40.9356 24.6991 42.832 25.6279C44.7803 26.5806 45.4347 27.1917 45.427 28.0439C45.4125 29.3479 43.8729 29.9234 42.4322 29.9458C39.9187 29.9849 38.4572 29.2638 37.2953 28.7184L36.3899 32.9765C37.5556 33.5163 39.7141 33.9872 41.9524 34.0078C47.2065 34.0078 50.6439 31.4012 50.6625 27.3599C50.6831 22.2309 43.6035 21.947 43.6518 19.6544C43.6685 18.9593 44.3285 18.2175 45.7748 18.0288C46.4906 17.9336 48.4668 17.8606 50.7073 18.8975L51.5866 14.7777C50.3817 14.3368 48.8332 13.9146 46.9052 13.9146C41.9599 13.9146 38.4816 16.5566 38.4535 20.3382ZM60.0363 14.2694C59.0769 14.2694 58.2684 14.8319 57.9076 15.695L50.4023 33.7052H55.6526L56.6974 30.8033H63.1131L63.7192 33.7052H68.3467L64.3085 14.2694H60.0363ZM60.7708 19.5198L62.286 26.8181H58.1363L60.7708 19.5198ZM32.0879 14.2697L27.9494 33.705H32.9525L37.089 14.2692H32.0879M24.6866 14.2692L19.4791 27.4982L17.3726 16.2501C17.1255 14.9945 16.1494 14.2694 15.0654 14.2694H6.55282L6.43359 14.8338C8.18119 15.2149 10.1668 15.8296 11.3697 16.4874C12.1059 16.8891 12.3158 17.2404 12.5577 18.1951L16.5474 33.7052H21.8345L29.9403 14.2694H24.6866",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2056_9522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.9131,
    height: 20.1739,
    fill: "white",
    transform: "translate(6.43359 13.9141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardVisa);
export default __webpack_public_path__ + "static/media/icon-card-visa.e268238fb747de76dfbac93ca83a5ba6.svg";
export { ForwardRef as ReactComponent };